module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABLUlEQVQ4T9WUwXGDQAxFJRqIS3AJLoES3EHMBe3eSAWxOyAnEBcoISXQgV0CJSRXDquMPDCzgWW8B1+so2b38b/0F4QnFz6ZBy8ObJrmICLvInLQ0SDizTn3Za0dtka1abmu6xIRFVQS0bcCmPkIAAUAXInoIwQNApm5A4CBiM6hS8x8FpGdMUbh/2oFrKoqRcTCGKNq7qUA51xvre29Xu+cOy3tr4CqDhHLPM9vD4BHEUmXKkPAnohS30dI4aR8dTYaCABCRJfFh6KAK8tt2+7GcSw0PvNsdeNRlkNLmVUpOMuyn9muLs+f9T2rG7Hopq1qfFbFzKp2HxUbb7MKe0PEy6xiejmfAPBLRKfoYM8H1X6SJHpxP/UG51zn5/FhsLfeaGz/xX9fsTb9c38zbbIVgpJ6JQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pubmedSearch/history.png
// module id = 30Oh
// module chunks = 1